import script from "./CartListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CartListItem.vue?vue&type=script&setup=true&lang=js"

import "./CartListItem.vue?vue&type=style&index=0&id=3b0b5ead&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b0b5ead"]])

export default __exports__